import ExportParametersTable from './ExportParametersTable';
import NoData from 'components/Common/NoData';
import PageHeader from 'components/Common/PageHeader';
import React, { useEffect, useState } from 'react';
import { HSpinner } from 'BaseComponents';
import { crumbs } from 'components/Common/BreadcrumbsNavigation';
import { useFetchExportParameters } from 'api/internalAdmin/exports/useFetchExportParameters';


const ExportParameters = () => {
  const {
    data, isLoading, isError, refetch,
  } = useFetchExportParameters();
  const [allParameters, setAllParameters] = useState([]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (data && data.partnerAccounts) {
      const params = data.partnerAccounts.flatMap(acc => acc.parameters || []);
      setAllParameters(params);
    }
  }, [data]);

  return (
    <>
      <PageHeader title='Export Parameters' breadcrumbs={[crumbs.helium, crumbs.internalAdmin]} />
      {
        isLoading && <HSpinner />
      }
      {
        isError && <NoData />
      }
      {
        (!isLoading && !isError) && <ExportParametersTable parameters={allParameters} />
      }
    </>
  );
};

export default ExportParameters;
